import React from 'react';
import { withRouter, BrowserRouter as Router, useLocation } from  'react-router-dom';
import PropTypes from 'prop-types';

import { compose, withHandlers, lifecycle, withState } from 'recompose';

import { connect } from 'react-redux';

import { MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import Routes from '../Components/Routes';
import Footer from '../Components/Footer';
import Header from '../Components/Header';

import { theme, commonStyles, COLORS } from '../styles/styles';
import logoLong from '../assets/icon_new.svg';
  //import logoLong from '../assets/futureshiftLong.png';
//import logoLong from '../assets/futureShiftSmall.png';
import 'typeface-roboto';
import BreadCrumbArea from '../Components/BreadCrumbArea';
import { messageList } from '../redux/selectors';
import MessageList from '../Components/MessageList';
import ChangeProfilePopup from '../Components/Popups/ChangeProfilePopup';
import { selectUserPrograms, selectUserModule, toggleSplashView, selectAssessment, selectRollout, setApproved, setCost, selectUserContent, setReference } from '../redux/reducers/userProgramsFull';
import { authUserRequest, getTokenFromCookies, logoutUserRequest, authAdminRequest } from '../redux/reducers/login';
import AddCodePopup from '../Components/Popups/AddCodePopup';
import SaveEditPopup from '../Components/Popups/SaveEditPopup';
import Notification from '../Components/Popups/Notification';

import { FaExclamation } from 'react-icons/fa';
import InviteDeclineReasonPopup from '../Components/Popups/InviteDeclineReasonPopup';
import ThinkToolPopup from '../Components/Popups/ThinkToolPopup';

import { withCookies, Cookies } from 'react-cookie';

import PropagateLoader from 'react-spinners/PropagateLoader'
import {read_cookie} from 'sfcookies'
import LoadingScreen from 'react-loading-screen';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { connectedUsersRequest } from '../redux/reducers/connectedUsers';
import SystemPopup from '../Components/Popups/SystemPopup';

import Announcements from '../Components/Popups/Announcements';
import LogbookPopup from '../Components/Popups/LogbookPopup';
import CookieConsent from "react-cookie-consent";
import ModalPopup from '../Components/Popups/ModalPopup';
import { FOOTER_TEXTS, API_LINK, APP_LINK } from '../constants';
import {
  proctoringBaseUrl,
  resolveVirgilExamWindow,
  isExamActiveInWindow,
  examStartAtForWidget,
} from '../utils/proctoringExamTimes';
import { recordProctoringSystemCheck } from '../utils/proctoringSystemCheckStorage';

import UpdatePopup from '../Components/Popups/UpdatePopup';
import ZoomPopup from '../Components/Popups/ZoomPopup';

import { checkDownloadRequest, checkUploadRequest } from '../redux/reducers/checkInternet';
import ModalRegistrationPopup from '../Components/Popups/ModalRegistrationPopup';
import ResubmissionPopup from '../Components/Popups/ResubmissionPopup';
import { assignmentRequestRequest, setMediaType, setRequestType } from '../redux/reducers/assignmentRequest';
import ExtensionPopup from '../Components/Popups/ExtensionPopup';
import PagePopup from '../Components/Popups/PagePopup';
import { popiRequest, showEula, showPopi } from '../redux/reducers/popi';
import { turnitinEulaRequest, turnitinRequest } from '../redux/reducers/turnitin';
import NotificationFire from '../firebaseNotifications/Notification'
import TurnitinModal from '../Components/TurnitinModal';
import SubmitExamModal from '../Components/SubmitExamModal';
import SaveModal from '../Components/SaveModal';
import ReturnModal from '../Components/ReturnModal';
import { setReturnItem, showReturnModal } from '../redux/reducers/view';
import authHOC from '../Components/AuthHOC';
import ExampleModal from '../Components/ExampleModal';
import DiabilityModal from '../Components/DiabilityModal';
import { xapiRequest } from '../redux/reducers/xapi';
import PollModal from '../Components/Popups/PollModal';
import LogoutModal from '../Components/LogoutModal';
import ProctoringWidget from '@shaunstapes/proctoring-widget';
import { setAdminFeedRequested } from '../redux/reducers/view';
const cookies = new Cookies();




const App = ({
  classes,
  handlePollClose,
  showSystem,
  handleAgreeEula,
  handleAgree,
  internet,
  parsedHash,
  showProfile,
  selectUserPrograms,
  selectUserModule,
  loginReducer,
  programs,
  view,
  programsFull,
  handlePolicyPopup,
  showPolicy,
  popups,
  handleTerms,
  showTerms,
  ...props
}) => {
  const u = loginReducer && loginReducer.user;
  const base = proctoringBaseUrl(API_LINK);
  const { startMs, endMs } = resolveVirgilExamWindow(u, programsFull);
  const examWindowActive =
    u && u.is_virgil == 1 && isExamActiveInWindow(startMs, endMs);
  const examStartAtProp =
    u && u.is_virgil == 1 ? examStartAtForWidget(startMs) : undefined;
  const modelsBaseUrlResolved = base ? `${base}/models` : '/models';

  return (
  <MuiThemeProvider theme={theme}>
    
    <div className="mainBg-grey"></div>
    <div className="noView">
      <div className="z-depth-3  noView-container" >
        <div style={{height:25, textAlign: 'center'}} className="secondary-color w-100">
        <FaExclamation style={{color: '#ffffff',paddingTop: 7,fontSize: 13,paddingRight: 10,paddingLeft: 10}} />
        </div>
        <div style={{padding: 10, fontSize: 13}}>
          This is better viewed in portrait.
        </div>
      </div>
      <div className="noView-bg"></div>
    </div>
    <div className="app-background">
      <div className={classes.root}>
        {loginReducer.user  && <Header /> }
        {loginReducer.user  && <BreadCrumbArea /> }
        {/*loginReducer.user && window.zE("messenger", "loginUser", function (callback) {
       callback(loginReducer.user.zendesk_token)
     })*/}
        <Routes />
        <MessageList/>
        <ChangeProfilePopup/>
        <AddCodePopup />
        <ResubmissionPopup />
        <ExtensionPopup />
        <Notification />
        <ModalRegistrationPopup/>
        <SaveModal/>
        <ReturnModal/>

        {loginReducer.user && props.pollSetup.showPolls && <PollModal style={{display:'none'}} path={APP_LINK+"surveygenerator/?standalone=true&pid="+props.pollSetup.polls[0].poll_id+"&sid="+props.pollSetup.polls[0].survey_id+"&type_id=16&uid="+loginReducer.user.userId} compulsory={props.pollSetup.polls[0].mandatory} pollName={props.pollSetup.polls[0].name} handleClose={handlePollClose}/>}
        {/* <ModalRegistrationForm/> */}
        {view.declineInviteReasonPopup && <InviteDeclineReasonPopup />}
        {!showSystem && <SystemPopup/>}
        {popups.length>0 && (
          <div>

            {popups.map((item, index) => (
             
      <ZoomPopup
      pathToIframeFile={item.path}
      selectedContent={item}
      zDepth = {index}
    />
    
   ))}
  
          </div>
        )}
        <div id="popup-container" style={{width:'100%', height:'calc(100% - 87px)', top:61,left:0, right:0, bottom:0, position:'fixed', zIndex:"99999", pointerEvents:'none'}}/>
        <div id="popup-container2" style={{width:'100%', height:'calc(100% - 87px)', top:61,left:0, right:0, bottom:0, position:'fixed', zIndex:"99999",  pointerEvents:'none'}}/>
        <ThinkToolPopup popup={view.thinkToolPopup}/>
        <SaveEditPopup/>
      </div>
      <Announcements/>
      <div><Footer handleTerms={handleTerms}/></div>
      <TurnitinModal/>
      <SubmitExamModal/>
      <DiabilityModal/>
      {loginReducer.user && loginReducer.user.is_virgil==1 && <div id="proctoring-container" style={{ 
  position: 'absolute',
  left: 0,
  top: examWindowActive ? 50 : 0,
  right: 0,
  bottom: 0,
  width: examWindowActive ? '100%' : 0,
  height: examWindowActive ? '100%' : 0,
  minHeight: examWindowActive ? '100vh' : 0,
  padding: examWindowActive ? '20px' : 0,
  zIndex: examWindowActive ? 1000 : -1,
  pointerEvents: examWindowActive ? 'auto' : 'none',
  overflow: 'hidden',
}}><ProctoringWidget
        userId={loginReducer.user.userId}
        examId={loginReducer.user.virgil_examId}
        apiBaseUrl={base || undefined}
        websocketUrl={base || undefined}
        modelsBaseUrl={modelsBaseUrlResolved}
        showDebug={false}
        showVideo={false}
        examIsActive={!!examWindowActive}
        start={!!examWindowActive}
        examStartAt={examStartAtProp}
        enableNoiseMonitoring={true}
        enableLightingMonitoring={true}
        onViolation={(v) => console.log('Violation:', v)}
        onSystemCheckComplete={() => {
          if (u && u.userId != null && u.virgil_examId != null) {
            recordProctoringSystemCheck(u.userId, u.virgil_examId);
          }
        }}
        sendAdminFeed={(props.view && props.view.adminFeedRequested) === true}
      /></div>}
     
      <LogoutModal />
    </div>

    {showPolicy && <ModalPopup type='success' color='success' title='Cookie Policy' body={FOOTER_TEXTS.cookie} handleClose={handlePolicyPopup()} showClose={true}/>}
   

     {(programsFull.showSplashView && loginReducer.isLoggedIn) && <div style={{backgroundColor:COLORS.grey, width:"100%", height:"100%", position:'absolute', top:0, left:0, zIndex:12000, textAlign: 'center'}}>
     <div style={{textAlign:'center', width:'100%'}}>
      <div style={{ width:400, margin:'0 auto', padding:22}}>
      <h5  style={{color:'#FFFFFF',fontFamily:'PTSans-Regular', width:"100%", textAlign:'center',fontSize:16, marginTop:80}}>Please hang on... we are busy logging you in.</h5>
      <h5  style={{color:'#FFFFFF',fontFamily:'PTSans-Regular', width:"100%", textAlign:'center',fontSize:25, marginTop:30}}>If this is taking too long, please check your internet connectivity and clear your browser cache before refreshing.</h5>
      
      </div>
      </div>
      
      <div style={{position: 'absolute',top: '50%',left: '50%',transform: 'translate(-50%,-50%)',width: 200,height: 200,}}>
      <img src={logoLong} style={{height:100, marginBottom:10}}/>
      <div style={{textAlign:'center', position:'absolute', left:"50%", marginTop:15}}>
        
      <PropagateLoader
         
         sizeUnit={"px"}
         size={15}
         color={'#FFFFFF'}
         loading={true}
       />
      </div>
 
     
       <div style={{width:300}}>
        {navigator.connection && <h5 className="gothamBlack" style={{color:'#FFFFFF', width:"100%", textAlign:'left',fontSize:12, marginTop:45}}>Network Type: {navigator.connection.effectiveType}</h5>}
        {navigator.connection && <h5 className="gothamBlack" style={{color:'#FFFFFF', width:"100%", textAlign:'left',fontSize:12, marginTop:10}}>Estimated Download Speed: {navigator.connection.downlink} MB/s</h5>}
        {navigator.connection && <h5 className="gothamBlack" style={{color:'#FFFFFF', width:"100%", textAlign:'left',fontSize:12, marginTop:10}}>Ping: {navigator.connection.rtt} ms</h5>}
        <h5 className="gothamBlack" style={{color:'#FFFFFF', width:"100%", textAlign:'left',fontSize:12, marginTop:10}}>Actual Download Speed: {internet.downloadSpeed} mb/s</h5>
    
       </div>
        
      </div>
       
    </div>}
  
   
    
    {props.version.PWAcurrent!=props.version.PWANew && 
    <UpdatePopup/>
    
    }
      {props.popiReducer.showPopi && <PagePopup handlePopupToggle={handleAgree} markup={FOOTER_TEXTS.popi} title={'POPI'} />}
      {props.popiReducer.showEula && <PagePopup handlePopupToggle={handleAgreeEula} markup={props.popiReducer.eula} title={'TURN IT IN EULA'} />}
  
    {showTerms && <ModalPopup type='success' showModal={true} color='success' title='Terms &amp; Conditions' body={FOOTER_TEXTS.privacy} handleClose={handleTerms} closeModal = {() => handleTerms()} showClose={true}/>}
    <CookieConsent
    location="bottom"
    buttonText="I Accept"
    cookieName="cpsCookie"
    style={{ background: "#2B373B" }}
    buttonStyle={{ backgroundColor: "#13a2d9",color: "#FFFFFF", fontSize: "13px" }}
    expires={150}
    enableDeclineButton
    onDecline={() => {handlePolicyPopup()}}
    
    declineButtonText="Cookie Policy"
    setDeclineCookie={false}
    declineButtonStyle={{ color: "#FFFFFF", fontSize: "13px" }}>
    This website uses cookies to enhance the user experience. By using CPS Learn you accept our use of cookies.
</CookieConsent>
<NotificationFire/>
{/* <ExampleModal/> */}
   
  </MuiThemeProvider>
  
  );
};

App.propTypes = {
  classes: PropTypes.instanceOf(Object),
};

const styles = () => ({
  ...commonStyles,
  root: {
    height:"100%",
    flexGrow: 1
  }
});

const mapStateToProps = state => ({
  teamMembersFull: state.teamMembersFullReducer,
  showProfile: state.userProgramsFullReducer.showProfile,
  loginReducer: state.loginReducer,
  view: state.viewReducer,
  programs: state.userProgramsFullReducer.programs,
  programsFull:state.userProgramsFullReducer,
  version:state.PWAReducer,
  popups: state.viewReducer.popups,
  internet:state.checkInternetReducer,
  popiReducer:state.popiReducer,
  view: state.viewReducer
  
});

const mapDispatchToProps = dispatch => ({
  toggleSplashView: bool => dispatch(toggleSplashView(bool)),
  selectUserPrograms: programId => dispatch(selectUserPrograms(programId)),
  selectUserModule: moduleId => dispatch(selectUserModule(moduleId)),
  selectAssessment: surveyId => dispatch(selectAssessment(surveyId)),
  selectRollout: rolloutId => dispatch(selectRollout(rolloutId)),
  selectUserContent: contentId => dispatch(selectUserContent(contentId)),
  setRequestType: type => dispatch(setRequestType(type)),
  setApproved: int => dispatch(setApproved(int)),
  logoutUserRequest: token => dispatch(logoutUserRequest(token)),
  turnitinEulaRequest: () => dispatch(turnitinEulaRequest()),
  checkDownload: () => dispatch(checkDownloadRequest()),
  checkUpload: () => dispatch(checkUploadRequest()),
  setCost: type => dispatch(setCost(type)),
  setMediaType: string => dispatch(setMediaType(string)),
  assignmentRequestRequest: (type) => dispatch(assignmentRequestRequest(type)),
  popiRequest: () => dispatch(popiRequest()),
  showPopi: bool => dispatch(showPopi(bool)),
  showEula: bool => dispatch(showEula(bool)),
  setReference:string => dispatch(setReference(string)),
  turnitinRequest:()=>dispatch(turnitinRequest()),
  showReturnModal:string => dispatch(showReturnModal(string)),
  setReturnItem:string => dispatch(setReturnItem(string)),
  getToken: token => dispatch(getTokenFromCookies(token)),
  authUser: () => dispatch(authUserRequest()),
  xapiRequest: (string) => dispatch(xapiRequest(string)),
  authAdmin: (obj) => dispatch(authAdminRequest(obj)),
  setAdminFeedRequested: (val) => dispatch(setAdminFeedRequested(val)),
});


export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withState('showPolicy', 'togglePolicy', false),
  withState('showTerms', 'toggleTerms', false),
  withState('showSystem', 'toggleSystem', false),
  withState('pollSetup', 'setPollSetup', {}),
  withState('examActive', 'setExamActive', false),
  withState('monitoringLatched', 'setMonitoringLatched', false),
  withHandlers({
    handleTabValueChange: props => (event, value) => {props.handleChangeTabValue(value)},
    handlePolicyPopup: props => () => {
      props.togglePolicy(!props.showPolicy)
    },
    handleTerms: props => () => {
      props.toggleTerms(!props.showTerms)
    },
    handleAgree: props => () => {
      props.popiRequest()
      props.showPopi(false)
    },
    handleAgreeEula: props => () => {
      props.turnitinEulaRequest()
      props.showEula(false)
    },
    handlePollClose: props => () => {
      // Remove the first poll
      const updatedPolls = props.pollSetup.polls.slice(1);

      // Update the state based on the updated polls array
      if (updatedPolls.length > 0) {
        props.setPollSetup({ polls: updatedPolls, showPolls: true });
      } else {
        props.setPollSetup({ polls: [], showPolls: false });
      }
    },
    useQuery:props => () => {
      const search = props.location.search; // could be '?foo=bar'
      const params = new URLSearchParams(search);
      const foo = params.get('systemDown'); // bar
      
      if( props.location.search=='?system=true'){

        props.toggleSystem(true)
      }
      //props.toggleSystem(true)
      
      if (params.get('adminfeed') === 'true') {
        props.setAdminFeedRequested(true);
        console.log('[Proctor] Admin feed requested via query param');
      }
      
    }
  }),
  lifecycle({
    componentDidMount(){
      this.props.toggleSplashView(true);
      this.props.checkDownload();
      this.props.useQuery();
      const computeExamActive = (p, prev) => {
        const u = p.loginReducer && p.loginReducer.user;
        if (!u) return prev;
        if (u.is_virgil != 1) return false;
        const pf = p.programsFull || {};
        const { startMs, endMs } = resolveVirgilExamWindow(u, pf);
        return isExamActiveInWindow(startMs, endMs, Date.now());
      };
      {
        const nextActive = computeExamActive(this.props, this.props.examActive);
        if (this.props.examActive !== nextActive) this.props.setExamActive(nextActive);
        // Latch monitoring on first active
        if (nextActive && !this.props.monitoringLatched) this.props.setMonitoringLatched(true);
      }
      this._examTimer = setInterval(() => {
        const nextActive = computeExamActive(this.props, this.props.examActive);
        if (this.props.examActive !== nextActive) this.props.setExamActive(nextActive);
        // Keep latched while active; release when exam ends
        if (nextActive && !this.props.monitoringLatched) this.props.setMonitoringLatched(true);
        if (!nextActive && this.props.monitoringLatched) this.props.setMonitoringLatched(false);
      }, 15000);
      // Periodic frame sanity check (non-black frames)
      this._frameCheckTimer = setInterval(() => {
        try {
          const container = document.getElementById('proctoring-container');
          if (!container) return;
          const video = container.querySelector('video');
          if (!video || video.readyState < 2) {
            // console.log('[Proctor] Frame check: no video ready');
            return;
          }
          const w = video.videoWidth || 640;
          const h = video.videoHeight || 480;
          const canvas = document.createElement('canvas');
          canvas.width = w; canvas.height = h;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(video, 0, 0, w, h);
          const { data } = ctx.getImageData(0, 0, w, h);
          let sum = 0, black = 0; const total = w * h;
          for (let i = 0; i < data.length; i += 4) {
            const r = data[i], g = data[i+1], b = data[i+2];
            const y = 0.2126*r + 0.7152*g + 0.0722*b; // luma
            sum += y; if (y < 5) black++;
          }
          const avg = Math.round(sum / total);
          const blackRatio = Math.round((black / total) * 100);
          console.log('[Proctor] Frame check', { avgLuma: avg, blackPct: blackRatio, ts: new Date().toISOString() });
        } catch (e) {
          // swallow
        }
      }, 5000);
      if(cookies.get('returnItem') ){
       this.props.setReturnItem(JSON.parse(read_cookie('returnItem')))
      }
      //this.props.turnitinRequest();
    },
    componentWillUnmount(){
      if (this._examTimer) clearInterval(this._examTimer);
      if (this._frameCheckTimer) clearInterval(this._frameCheckTimer);
    },
    componentWillReceiveProps(nextProps){
      if(this.props.popiReducer.showPopi==false && nextProps.popiReducer.showPopi==true){
        this.props.xapiRequest({xapiType:'Registered'})
      }
      if(!this.props.loginReducer.user && nextProps.loginReducer.user){
        this.props.xapiRequest({xapiType:'Logged In'})
      }
      if(this.props.view.returnItem != nextProps.view.returnItem && nextProps.loginReducer.user && this.props.view.returnItem.type!='Assignments'){
         this.props.showReturnModal(true)
       }
      
      if( (this.props.programsFull.isFetched==false && nextProps.programsFull.isFetched==true )){
        this.props.toggleSplashView(false);
        const search = nextProps.location.search; // could be '?foo=bar'
        const params = new URLSearchParams(search);
        if(params.get("accepted")=="true"){
          
          nextProps.selectUserPrograms(parseInt(params.get("program_id")))
          nextProps.selectUserModule(parseInt(params.get("module_id")))
          nextProps.selectAssessment(parseInt(params.get("survey_id")))
          nextProps.selectRollout(parseInt(params.get('rollout_id')))
          nextProps.setRequestType(params.get('type'))
          nextProps.setCost(params.get('cost'))
          nextProps.selectUserContent(parseInt(params.get('content_id')))
          nextProps.setApproved(1)
          nextProps.setReference(params.get('reference'))
          nextProps.assignmentRequestRequest(params.get('type'))
          nextProps.setMediaType('pop')
        }
      }else{
        
      }
      if(nextProps.loginReducer.user && nextProps.loginReducer.user.popiApproved==0 && !this.props.loginReducer.user){
        this.props.showPopi(true)
      }
      if(nextProps.loginReducer.user && !this.props.loginReducer.user){
        if(nextProps.loginReducer.user.polls && nextProps.loginReducer.user.polls.length>0){
       
         var obj  = { 
             polls: nextProps.loginReducer.user.polls,
             showPolls: true
         }
         this.props.setPollSetup(obj)
        }
        if(read_cookie('returnItem').length!=0 ){
          this.props.setReturnItem(JSON.parse(read_cookie('returnItem')))
         }
      }
      // if(this.props.internet.downloadSpeed!=nextProps.internet.downloadSpeed){
      //   this.props.checkUpload();
      // }
      // update exam activity on user changes
      const u = nextProps.loginReducer && nextProps.loginReducer.user;
      if (u) {
        const pf = nextProps.programsFull || {};
        const { startMs, endMs } = resolveVirgilExamWindow(u, pf);
        const active =
          u.is_virgil == 1 && isExamActiveInWindow(startMs, endMs, Date.now());
        if (this.props.examActive !== active) this.props.setExamActive(active);
        if (active && !this.props.monitoringLatched) this.props.setMonitoringLatched(true);
        if (!active && this.props.monitoringLatched) this.props.setMonitoringLatched(false);
      }
    }
  }),
  withCookies,
  authHOC,
  withStyles(styles),
)(App);
